/**
 * Template predefinito Bundle FHIR "richiesta valutazione assistito".
 * Usato come valore iniziale nell'editor JSON della pagina nuova richiesta.
 */
export const DEFAULT_BUNDLE = {
  resourceType: 'Bundle',
  type: 'message',
  timestamp: '2025-06-19T10:05:00Z',
  meta: {
    profile: [
      'https://si-cot.atenainformatica.it/fhir/StructureDefinition/Bundle-richiesta-valutazione-assistito'
    ]
  },
  entry: [
    {
      fullUrl: 'urn:uuid:7b2c4d6e-8f9a-4b1c-a2d3-e4f5c6b7a8d9',
      resource: {
        resourceType: 'MessageHeader',
        eventCoding: {
          system: 'http://terminology.hl7.org/CodeSystem/message-events',
          code: 'servicerequest-create',
          display: 'Creazione richiesta di valutazione assistito'
        },
        source: {
          name: 'Software source',
          endpoint: 'urn:endpoint:software-soruce'
        },
        sender: {
          reference: 'urn:uuid:8d7f1c2a-9e34-4b01-bd7a-5f3e2a1c0b9d'
        },
        destination: [
          {
            name: 'Sistema COT',
            endpoint: 'urn:endpoint:cot'
          }
        ],
        responsible: {
          reference: 'urn:uuid:3f6f0d3b-6f35-4a50-9c6a-8c3d7f2b1a10'
        },
        focus: [
          {
            reference: 'urn:uuid:5a9d8c7b-6e4f-4a2b-9c1d-0e3f2b1a4c5d'
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44',
      resource: {
        resourceType: 'Patient',
        identifier: [
          {
            system: 'http://hl7.it/sid/codiceFiscale',
            value: 'RSSMRA80A01C933H'
          }
        ],
        name: [
          {
            use: 'official',
            family: 'Rossi',
            given: ['Mario']
          }
        ],
        gender: 'male',
        birthDate: '1985-01-01',
        address: [
          {
            use: 'home',
            type: 'both',
            line: ['Via Roma 10'],
            city: 'Roma',
            postalCode: '00100',
            country: 'IT',
            extension: [
              {
                url: 'http://hl7.it/fhir/StructureDefinition/address-comune',
                valueCoding: {
                  system: 'https://www.hl7.it/fhir/base/CodeSystem/istat-comuni',
                  code: '110005',
                  display: 'Margherita di Savoia'
                }
              }
            ]
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:3f6f0d3b-6f35-4a50-9c6a-8c3d7f2b1a10',
      resource: {
        resourceType: 'Organization',
        identifier: [
          {
            system: 'http://hl7.it/sid/fls',
            value: '160113'
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:2b3a7b90-5e5e-4d5d-8c9b-1a2b3c4d5e6f',
      resource: {
        resourceType: 'Practitioner',
        identifier: [
          {
            system: 'http://hl7.it/sid/codiceFiscale',
            value: 'CQVRNN80A56A285X'
          }
        ],
        name: [
          {
            use: 'official',
            family: 'Sanna',
            given: ['Nino']
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:8d7f1c2a-9e34-4b01-bd7a-5f3e2a1c0b9d',
      resource: {
        resourceType: 'PractitionerRole',
        practitioner: {
          reference: 'urn:uuid:2b3a7b90-5e5e-4d5d-8c9b-1a2b3c4d5e6f'
        },
        organization: {
          reference: 'urn:uuid:3f6f0d3b-6f35-4a50-9c6a-8c3d7f2b1a10'
        },
        code: [
          {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/practitioner-role',
                code: 'doctor',
                display: 'Doctor'
              }
            ],
            text: 'Medico di Medicina Generale'
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:11111111-2222-3333-4444-555555555555',
      resource: {
        resourceType: 'RelatedPerson',
        patient: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        },
        relationship: [
          {
            text: 'Caregiver / tutore'
          }
        ],
        identifier: [
          {
            system: 'http://hl7.it/sid/codiceFiscale',
            value: 'RSSMRA80A01F205X'
          }
        ],
        name: [
          {
            use: 'official',
            family: 'Rossi',
            given: ['Anna']
          }
        ],
        telecom: [
          {
            system: 'phone',
            value: '+39 333 1234567',
            use: 'mobile'
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:a1b2c3d4-e5f6-47a8-9b0c-1d2e3f4a5b6c',
      resource: {
        resourceType: 'Encounter',
        status: 'finished',
        class: {
          system: 'http://terminology.hl7.org/CodeSystem/v3-ActCode',
          code: 'AMB',
          display: 'Ambulatory'
        },
        subject: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        },
        period: {
          start: '2025-06-19T08:00:00Z',
          end: '2025-06-19T10:00:00Z'
        }
      }
    },
    {
      fullUrl: 'urn:uuid:9e0a1b2c-3d4e-4f5a-8b9c-0d1e2f3a4b5c',
      resource: {
        resourceType: 'DocumentReference',
        status: 'current',
        type: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/v3-ActCode',
              code: 'DOCUMENT',
              display: 'Document'
            }
          ],
          text: 'Attestato di vaccinazione'
        },
        subject: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        },
        context: {
          encounter: [
            {
              reference: 'urn:uuid:a1b2c3d4-e5f6-47a8-9b0c-1d2e3f4a5b6c'
            }
          ]
        },
        author: [
          {
            reference: 'urn:uuid:3f6f0d3b-6f35-4a50-9c6a-8c3d7f2b1a10'
          }
        ],
        content: [
          {
            attachment: {
              contentType: 'application/pdf',
              data: 'U29tZSBmYWtlIGRvY3VtZW50IGNvbnRlbnQgZW5jb2RlZCBpbiBiYXNlNjQ=',
              title: 'Attestato di vaccinazione COVID-19',
              creation: '2025-06-19T08:30:00+02:00'
            }
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:4e1c2a9b-7f3d-4c8a-9e5b-1a2f3d4c6b7a',
      resource: {
        resourceType: 'Condition',
        clinicalStatus: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/condition-clinical',
              code: 'active'
            }
          ]
        },
        verificationStatus: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
              code: 'confirmed'
            }
          ]
        },
        category: [
          {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                code: 'problem-list-item',
                display: 'Problem List Item'
              }
            ]
          }
        ],
        severity: {
          coding: [
            {
              system: 'http://snomed.info/sct',
              code: '255604002',
              display: 'Mild'
            }
          ]
        },
        code: {
          coding: [
            {
              system: 'http://hl7.org/fhir/sid/icd-10-cm',
              code: 'E84.0',
              display: 'Cystic fibrosis with pulmonary manifestations'
            }
          ],
          text: 'Cystic Fibrosis'
        },
        subject: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        }
      }
    },
    {
      fullUrl: 'urn:uuid:aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
      resource: {
        resourceType: 'Observation',
        status: 'final',
        category: [
          {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/observation-category',
                code: 'exam',
                display: 'Exam'
              }
            ],
            text: 'Osservazione clinica'
          }
        ],
        code: {
          coding: [
            {
              system: 'http://snomed.info/sct',
              code: '40917007',
              display: 'Confusion'
            }
          ],
          text: 'Confusione mentale'
        },
        subject: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        },
        encounter: {
          reference: 'urn:uuid:a1b2c3d4-e5f6-47a8-9b0c-1d2e3f4a5b6c'
        },
        effectiveDateTime: '2025-06-19T09:50:00Z',
        performer: [
          {
            reference: 'urn:uuid:8d7f1c2a-9e34-4b01-bd7a-5f3e2a1c0b9d'
          }
        ],
        valueCodeableConcept: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/v2-0136',
              code: 'Y',
              display: 'Yes'
            }
          ],
          text: 'Presente'
        },
        basedOn: [
          {
            reference: 'urn:uuid:5a9d8c7b-6e4f-4a2b-9c1d-0e3f2b1a4c5d'
          }
        ],
        note: [
          {
            time: '2025-06-19T09:55:00Z',
            text: 'Sintomo riportato dal caregiver: confusione mentale.'
          }
        ]
      }
    },
    {
      fullUrl: 'urn:uuid:5a9d8c7b-6e4f-4a2b-9c1d-0e3f2b1a4c5d',
      resource: {
        resourceType: 'ServiceRequest',
        meta: {
          profile: [
            'https://si-cot.atenainformatica.it/fhir/StructureDefinition/ServiceRequest-richiesta-valutazione-assistito'
          ]
        },
        status: 'draft',
        intent: 'order',
        priority: 'routine',
        identifier: [
          {
            system: 'https://si-cot.atenainformatica.it/fhir/id/richiesta-valutazione',
            value: 'REQ-2026-19'
          }
        ],
        subject: {
          reference: 'urn:uuid:6c2c0e9a-3f8f-4b2a-9b2e-0e3b3e9c2a44'
        },
        encounter: {
          reference: 'urn:uuid:a1b2c3d4-e5f6-47a8-9b0c-1d2e3f4a5b6c'
        },
        authoredOn: '2025-06-19T10:00:00Z',
        occurrenceDateTime: '2025-06-19T10:30:00Z',
        requester: {
          reference: 'urn:uuid:11111111-2222-3333-4444-555555555555'
        },
        reasonCode: [
          {
            coding: [
              {
                system: 'http://snomed.info/sct',
                code: '22253000',
                display: 'Pain'
              }
            ],
            text: 'Sintomo'
          },
          {
            text: 'Confusione mentale e difficoltà alla deambulazione; recente caduta in casa'
          }
        ],
        reasonReference: [
          {
            reference: 'urn:uuid:4e1c2a9b-7f3d-4c8a-9e5b-1a2f3d4c6b7a'
          }
        ],
        supportingInfo: [
          {
            reference: 'urn:uuid:9e0a1b2c-3d4e-4f5a-8b9c-0d1e2f3a4b5c'
          }
        ],
        note: [
          {
            authorString: 'Sistema inviante',
            time: '2025-06-19T09:55:00Z',
            text: 'Note'
          }
        ],
        extension: [
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/uvm',
            valueBoolean: false
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/pdeConfermata',
            valueBoolean: false
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/assistenzaInfermieristica',
            valueBoolean: true
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/assistenzaRiabilitativa',
            valueBoolean: false
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/assistenzaSociale',
            valueBoolean: true
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/settingProposto',
            valueCodeableConcept: {
              coding: [
                {
                  system: 'https://si-cot.atenainformatica.it/fhir/CodeSystem/setting',
                  code: '2',
                  display: 'ASSISTENZA RESIDENZIALE'
                }
              ]
            }
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/settingBase',
            valueCodeableConcept: {
              coding: [
                {
                  system: 'https://si-cot.atenainformatica.it/fhir/CodeSystem/setting',
                  code: '1',
                  display: 'BASE'
                }
              ]
            }
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/dataDimissionePrevista',
            valueDate: '2025-06-30'
          },
          {
            url: 'https://si-cot.atenainformatica.it/fhir/StructureDefinition/strutturaRicevente',
            valueReference: {
              type: 'Organization',
              identifier: {
                system: 'https://www.hl7.it/fhir/terminology/CodeSystem/cs-asl',
                value: '120201'
              },
              display: 'ASL (codice 120201)'
            }
          }
        ]
      }
    }
  ]
} as const;
